import React from 'react';
import { InputProps } from './input.interface';
import classNames from 'classnames';

import './input.scss';

let id = 0;

const Input = React.forwardRef<HTMLInputElement, InputProps>(({
    type = 'input',
    className,
    value,
    name,
    disabled,
    label,
    small = false,
    error,
    onChange,
    onBlur,
    autoComplete = 'on',
    onKeyPress,
    min,
    max
}: InputProps, ref: React.Ref<HTMLInputElement>) => {
    const idx = id++;

    return (
        <div className="form-input">
            <input
                name={name}
                min={min || void 0}
                max={max || void 0}
                value={value}
                ref={ref}
                onChange={onChange}
                onKeyPress={onKeyPress}
                onBlur={onBlur}
                className={classNames(
                    className,
                    {
                        'input': true,
                        'input--small': Boolean(small),
                        'input--disabled': Boolean(disabled),
                        'input--error': Boolean(error)
                    }
                )}
                type={type}
                id={idx.toString()}
                disabled={disabled}
                placeholder={label}
                autoComplete={autoComplete}
                aria-label={name}
            />
            <label
                htmlFor={idx.toString()}
                className={classNames(
                    {
                        'input-label': true,
                        'input-label--small': Boolean(small),
                        'input-label--error': Boolean(error)
                    }
                )}
                data-label={label}
            />
            { error && (
                <span className="input-error-message">
                    Błąd:
                    {'  '}
                    {error}
                </span>
            )}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
